import * as actionTypes from './actionTypes';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { showAlertMessage } from './alertActions';
import { NOTIFICATION_TYPES } from '../../common/notificationHandler/NotificationHandler';
import { getToken, alertMessage } from '../../common/utils/constants';
import Config from '../../common/config/config';
import { isEmpty } from '../../common/utils/isEmpty';

const ldapAxios = axios.create({
  baseURL: 'http://CHI-RV-TT1:8013/api/LDAP/LoginLDAP',
  // baseURL: 'http://mpl-rv-tstatbld:8013/api/LDAP',
  headers: {
    'Cache-Control': 'no-cache, no-store',
  },
});

const tokenName = getToken();


export const loginUserSuccess = (data = '', info = '', type = '') => {
  const result = { ...data, ...info };
  if (type === 'reroute') {
    return {
      type: actionTypes.USER_INFO_SUCCESS,
      payload: result,
    };
  } else {
    return {
      type: actionTypes.USER_INFO_SUCCESS,
      payload: result,
    };
  }
};

export const userInfoSuccess = (data = '', info = '', type = '') => {
  const result = { ...data, ...info };
  if (type === 'reroute') {
    return {
      type: actionTypes.USER_INFO_SUCCESS,
      payload: result,
    };
  } else {
    return {
      type: actionTypes.USER_INFO_SUCCESS,
      payload: result,
    };
  }
};

export const loginUser = (user) => {
  //console.warn(user);
  localStorage.setItem('usercred', JSON.stringify(user));
  return (dispatch) => {
    return ldapAxios.post('/', user)
      .then(res => {
        const { data } = res;
        if(data.error === "Invalid Corp ID or password")
        {
          alertMessage('error', 'Invalid Corp ID or password', 'bottomRight');
        }
        if (!isEmpty(data) && !Object.keys(data).includes('error')) {
          if (res.status === 200) {
            axios.post(`${Config.API_URL}/login/`, data).then(loginRes => {
              if (loginRes.status === 200) {
                const token = loginRes?.data?.Token;
                const info = jwtDecode(token);
               sessionStorage.setItem(tokenName, token);
                dispatch(
                  showAlertMessage({
                    type: NOTIFICATION_TYPES.SUCCCESS,
                    message: `Welcome ${info?.FirstName}, ${info?.LastName}`,
                    description: '',
                  })
                );
                alertMessage('success', 'success', `Welcome ${info?.FirstName}, ${info?.LastName}`);
                //console.log(info);
                dispatch(loginUserSuccess(data, info));
                sessionStorage.setItem('userinfo', JSON.stringify({ ...data, ...info }));
                sessionStorage.setItem('userrole', JSON.stringify(info));
                localStorage.setItem('userinfo', JSON.stringify({ ...data, ...info }));
                localStorage.setItem('userrole', JSON.stringify(info));
                dispatch(userInfoSuccess(data, info));
              }
            }).catch(err => {
              alertMessage('error', err?.message, 'Error while login, Please Register.', 'bottomRight');
            })
          }
        } 
        else {
          dispatch(
            showAlertMessage({
              type: NOTIFICATION_TYPES.ERROR,
              message: data?.error,
              description: 'Please try again',
            })
          );
        }
      }).catch((err) => {
        alertMessage('error', err?.message, 'Error while login, Please try again.', 'bottomRight');
        dispatch(
          showAlertMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: 'Login failed',
            description: 'Please try again',
          })
        );
      });
  };
};

export const logoutUser = () => {
  sessionStorage.clear();
  localStorage.removeItem('userinfo');
  localStorage.removeItem('userrole');
  return {
    type: actionTypes.LOGOUT_USER,
    userData: { auth: false },
  };
};
